import { Suspense, lazy } from "react";

// Loaded on demand: the page uses the platform's settings parts, which the
// package entry must not import.
const Page = lazy(() => import("./TracksSettings").then((m) => ({ default: m.TracksSettings })));

/** Project → Settings → Tracks, in the Labeling section of the menu. */
export const TracksSettingsPage = (props) => (
  <Suspense fallback={null}>
    <Page {...props} />
  </Suspense>
);

TracksSettingsPage.title = "Tracks";
TracksSettingsPage.path = "/tracks";
TracksSettingsPage.exact = true;
TracksSettingsPage.menuSection = "labeling";
